// extracted by mini-css-extract-plugin
export var button = "_8n-0";
export var icon = "_8n-1";